import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import DrShannon from "./pages/DrShannon";
import Philosophy from "./pages/Philosophy";
import Modalities from "./pages/Modalities";
import ServicesOverview from "./pages/ServicesOverview";
import ServicesList from "./pages/ServicesList";
import WhoWeTreat from "./pages/WhoWeTreat";
import GeneralInfo from "./pages/GeneralInfo";
import WhatToExpect from "./pages/WhatToExpect";
import FAQ from "./pages/FAQ";
import Testimonials from "./pages/Testimonials";
import DownloadForms from "./pages/DownloadForms";
import OrderSupplements from "./pages/OrderSupplements";
import Resources from "./pages/Resources";
import Links from "./pages/Links";
import Handouts from "./pages/Handouts";
import RecommendedReading from "./pages/RecommendedReading";
import ComingSoon from "./pages/ComingSoon";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import { usePageTitle } from "./hooks/usePageTitle";

function MarketingRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dr-shannon" element={<DrShannon />} />
        <Route path="/the-medicine" element={<Philosophy />} />
        <Route path="/the-medicine/philosophy" element={<Philosophy />} />
        <Route path="/the-medicine/modalities" element={<Modalities />} />
        <Route path="/services" element={<ServicesOverview />} />
        <Route path="/services/overview" element={<ServicesOverview />} />
        <Route path="/services/services" element={<ServicesList />} />
        <Route path="/services/who-we-treat" element={<WhoWeTreat />} />
        <Route path="/clinic" element={<GeneralInfo />} />
        <Route path="/clinic/general-info" element={<GeneralInfo />} />
        <Route path="/clinic/what-to-expect" element={<WhatToExpect />} />
        <Route path="/clinic/faq" element={<FAQ />} />
        <Route path="/clinic/testimonials" element={<Testimonials />} />
        <Route path="/clinic/download-forms" element={<DownloadForms />} />
        <Route path="/clinic/order-supplements" element={<OrderSupplements />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/e-health-letter" element={<ComingSoon title="E-Health Letter" />} />
        <Route path="/resources/links" element={<Links />} />
        <Route path="/resources/recipes" element={<ComingSoon title="Recipes" />} />
        <Route path="/resources/events-classes" element={<ComingSoon title="Events / Classes" />} />
        <Route path="/resources/handouts" element={<Handouts />} />
        <Route path="/resources/articles" element={<ComingSoon title="Articles" />} />
        <Route path="/resources/recommended-reading" element={<RecommendedReading />} />
        <Route path="/resources/movies" element={<ComingSoon title="Movies" />} />
        <Route path="/resources/podcasts" element={<ComingSoon title="Podcasts" />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}

function Router() {
  const location = useLocation();
  usePageTitle();
  if (location.pathname.startsWith("/admin")) {
    return (
      <Routes>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }
  return <MarketingRoutes />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Router />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
